// PdfIcon.jsx

import React from 'react';

/**
 * PdfIcon
 *
 * @returns {ReactNode} The rendered component.
 */
const PdfIcon = React.memo(({ width = 24, height = 24, ...rest }) => {

  // ----- RENDER ----- //

  return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      opacity="0.2"
      d="M14.5 8C13.115 8 12 9.115 12 10.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5V23L38.25 21.75 37 8z"
    />
    <path
      fill="#c03630"
      d="M14.5 7C13.115 7 12 8.115 12 9.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5V22l-13.75-1.25L37 7z"
    />
    <path
      opacity="0.2"
      d="M37 8v12.5c0 1.3808 1.1193 2.5 2.5 2.5H52z"
    />
    <path
      fill="#f36961"
      d="M37 7v12.5c0 1.3808 1.1193 2.5 2.5 2.5H52L37 7z"
    />
    <path
      opacity="0.2"
      d="M29.976 25.562c-.57658 0-1.1158.28221-1.2462.74801-.4844 1.7858.05775 4.5474.96195 7.9883l-.27276.66618c-.69234 1.6876-1.5578 3.3684-2.3188 4.8599-3.1419 6.1475-5.5861 9.4644-7.2159 9.6968l-.0063-.0675c-.03537-.76682 1.3798-2.7439 3.2978-4.3158.20006-.1618 1.0538-.98776 1.0538-.98776s-1.1524.60834-1.4112.76522c-2.4035 1.4346-3.5995 2.872-3.7945 3.8261-.05788.2834-.02075.63212.22969.7753l.6145.30868c1.673.83744 3.7301-1.3645 6.465-6.1578 2.783-.91295 6.2554-1.7725 9.4169-2.2382 2.83 1.617 6.0762 2.3869 7.3235 2.0545.23734-.06275.487-.24905.6145-.42065.1-.15789.23979-.78965.23979-.78965s-.23466.31934-.42788.41348c-.7894.37264-3.2816-.24905-5.839-1.5002 2.2112-.23535 4.0534-.24442 5.0379.07025 1.2504.39912 1.2514.80824 1.2347.89158.01687-.06862.07287-.34272.066-.45941-.02837-.30008-.12088-.56804-.34744-.78965-.46284-.45599-1.6056-.68578-3.1629-.70636-1.1738-.01275-2.5812.09-4.109.30868-.70015-.40205-1.439-.84402-2.0244-1.3912-1.4846-1.3866-2.729-3.3118-3.5018-5.47.05275-.20691.10325-.40909.1493-.61306.21479-.96589.36896-4.1592.36896-4.1592s-.61168 2.399-.70778 2.7609c-.06175.22946-.13858.47438-.22684.72934-.46875-1.6474-.70636-3.244-.70636-4.455 0-.34224.02938-1.0082.12631-1.5348.04725-.37556.18325-.57059.3245-.66474.27946.06775.59229.49635.91886 1.2132.28044.61975.26271 1.3375.26271 1.7818 0 0 .30076-1.1.23115-1.7501-.04237-.39029-.4137-1.3944-1.2031-1.3826h-.06463l-.35174-.0038zm.26848 9.9739c.81689 1.6425 1.9435 3.2024 3.4214 4.4536.32946.27849.68.54344 1.0409.7925-2.6839.49914-5.5026 1.2013-8.1219 2.2986.47364-.84136.98576-1.758 1.5104-2.7465 1.0159-1.921 1.6315-3.4028 2.1492-4.7981z"
    />
    <path
      fill="#ffffff"
      d="M29.976 24.562c-.57658 0-1.1158.28221-1.2462.74801-.4844 1.7858.05775 4.5474.96195 7.9883l-.27276.66618c-.69234 1.6876-1.5578 3.3684-2.3188 4.8599-3.1419 6.1475-5.5861 9.4644-7.2159 9.6968l-.0063-.0675c-.03537-.76682 1.3798-2.7439 3.2978-4.3158.20006-.1618 1.0538-.98776 1.0538-.98776s-1.1524.60834-1.4112.76522c-2.4035 1.4346-3.5995 2.872-3.7945 3.8261-.05788.2834-.02075.63212.22969.7753l.6145.30868c1.673.83744 3.7301-1.3645 6.465-6.1578 2.783-.91295 6.2554-1.7725 9.4169-2.2382 2.83 1.617 6.0762 2.3869 7.3235 2.0545.23734-.06275.487-.24905.6145-.42065.1-.15789.23979-.78965.23979-.78965s-.23466.31934-.42788.41348c-.7894.37264-3.2816-.24905-5.839-1.5002 2.2112-.23535 4.0534-.24442 5.0379.07025 1.2504.39912 1.2514.80824 1.2347.89158.01687-.06862.07287-.34272.066-.45941-.02837-.30008-.12088-.56804-.34744-.78965-.46284-.45599-1.6056-.68578-3.1629-.70636-1.1738-.01275-2.5812.09-4.109.30868-.70015-.40205-1.439-.84402-2.0244-1.3912-1.4846-1.3866-2.729-3.3118-3.5018-5.47.05275-.20691.10325-.40909.1493-.61306.21479-.96589.36896-4.1592.36896-4.1592s-.61168 2.399-.70778 2.7609c-.06175.22946-.13858.47438-.22684.72934-.46875-1.6474-.70636-3.244-.70636-4.455 0-.34224.02938-1.0082.12631-1.5348.04725-.37556.18325-.57059.3245-.66474.27946.06775.59229.49635.91886 1.2132.28044.61975.26271 1.3375.26271 1.7818 0 0 .30076-1.1.23115-1.7501-.04237-.39029-.4137-1.3944-1.2031-1.3826h-.06463l-.35174-.0038zm.26848 9.9739c.81689 1.6425 1.9435 3.2024 3.4214 4.4536.32946.27849.68.54344 1.0409.7925-2.6839.49914-5.5026 1.2013-8.1219 2.2986.47364-.84136.98576-1.758 1.5104-2.7465 1.0159-1.921 1.6315-3.4028 2.1492-4.7981z"
    />
    <path
      opacity="0.2"
      fill="#ffffff"
      d="M14.5 7C13.115 7 12 8.115 12 9.5v1C12 9.115 13.115 8 14.5 8H37c0-1 0 0 0-1z"
    />
  </svg>
  );
});

// Dev Tools
PdfIcon.displayName = 'PdfIcon';

export default PdfIcon;
